import axiosInstance from "../api/axios-config";

export interface TokenInfo {
  isValid: boolean;
  exp?: number;
  expiresIn?: string;
  sub?: string;
  role?: string;
}

/**
 * Parse un token JWT et retourne ses informations
 */
export function parseJwt(token: string): any {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    console.error("Failed to parse JWT token:", e);
    return null;
  }
}

/**
 * Vérifie si un token JWT est valide et non expiré
 */
export function checkTokenValidity(token: string): TokenInfo {
  if (!token) {
    return { isValid: false };
  }

  try {
    const parsed = parseJwt(token);
    if (!parsed) {
      return { isValid: false };
    }

    const exp = parsed.exp * 1000; // Convertir en millisecondes
    const now = Date.now();
    const isValid = exp > now;

    const expiresIn = isValid
      ? new Date(exp).toLocaleString()
      : "Expiré le " + new Date(exp).toLocaleString();

    return {
      isValid,
      exp,
      expiresIn,
      sub: parsed.sub,
      role: parsed.role,
    };
  } catch (e) {
    console.error("Error checking token validity:", e);
    return { isValid: false };
  }
}

/**
 * Teste une requête authentifiée vers le backend
 */
export async function testAuthRequest(
  baseUrl: string,
  token: string
): Promise<boolean> {
  try {
    const response = await axiosInstance.get(`${baseUrl}/auth/me`, {});
    return response.status === 200;
  } catch (e) {
    console.error("Auth test request failed:", e);
    return false;
  }
}
